"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnregisterPushTokenRequestSchema = exports.RegisterPushTokenRequestSchema = void 0;
const zod_1 = require("zod");
const driverOnboarding_1 = require("./driverOnboarding");
// Schema-first: the type is `z.infer`-derived below, not a hand-written interface checked
// against the schema (see driver-preferences.ts / organization.ts for the same pattern). An
// explicit `z.ZodType<RegisterPushTokenRequest>` annotation here type-checks under this
// package's own build but fails under the TS version apps/routing-functions' test runner
// resolves for this same source file via its jest moduleNameMapper.
exports.RegisterPushTokenRequestSchema = zod_1.z.object({
    expoPushToken: zod_1.z.string().min(1),
    platform: zod_1.z.enum(['ios', 'android']),
    // Optional: older installed app builds won't send this yet. The backend falls back to German,
    // matching the notification copy it sent before this field existed.
    languageCountryCode: zod_1.z.nativeEnum(driverOnboarding_1.DriverOnboardingLanguage).optional(),
});
// Same reason as RegisterPushTokenRequestSchema above
exports.UnregisterPushTokenRequestSchema = zod_1.z.object({
    expoPushToken: zod_1.z.string().min(1),
});
//# sourceMappingURL=pushToken.js.map